import React from "react";

const steps = [
  {
    title: "Send an Enquiry",
    media: "https://legalseba.com/wp-content/uploads/2019/07/icon-landing-name.gif.webp",
    type: "image",
  },
  {
    title: "Get Free Consultation",
    media: "https://legalseba.com/wp-content/uploads/2019/07/icon-landing-checkout.gif.webp",
    type: "image",
  },
  {
    title: "Make The Initial Payment",
    media: "https://legalseba.com/wp-content/uploads/2019/07/icon-landing-package.gif.webp",
    type: "image",
  },
  {
    title: "Submit The Documents",
    media: "https://cdn-icons-gif.flaticon.com/17490/17490068.gif",
    type: "image",
  },
  {
    title: "Incorporated",
    media: "https://cdn-icons-mp4.flaticon.com/512/15332/15332396.mp4",
    type: "video",
  },
];

export default function WorkingProcess1() {
  return (
    <section style={{ padding: "80px 20px", backgroundColor: "#f4f9ff" }}>
      <h1
        style={{
          color: "#0d6efd",
          fontSize: "36px",
          fontWeight: "800",
          textAlign: "center",
          marginBottom: "60px",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        Our Working Process
      </h1>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
        {steps.map((step, index) => (
          <div
            key={index}
            style={{
              width: "160px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              transition: "transform 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            {/* Circle with media */}
            <div
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #ffffff, #e0f0ff)",
                boxShadow: "0 0 12px rgba(0, 102, 255, 0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
                overflow: "hidden",
                border: "2px solid #0d6efd",
              }}
            >
              {step.type === "image" ? (
                <img
                  src={step.media}
                  alt={step.title}
                  style={{ width: "60px", height: "60px", objectFit: "contain" }}
                />
              ) : (
                <video
                  src={step.media}
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{ width: "60px", height: "60px", objectFit: "contain", borderRadius: "8px" }}
                />
              )}
            </div>

            {/* Step Text */}
            <div
              style={{
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "600",
                color: "#333",
                lineHeight: "1.4",
              }}
            >
              <span
                style={{
                  display: "block",
                  fontSize: "14px",
                  color: "#0d6efd",
                  fontWeight: "700",
                  marginBottom: "4px",
                }}
              >
                Step {index + 1}
              </span>
              {step.title}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}